<template>
  <div>
    <b-sidebar
      id="sidebar-create-consultant"
      sidebar-class="sidebar-xg"
      :visible="newEmployeeSidebar.visible"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
      @shown="onShow"
      @change="(val) => mutateNewEmployeeSidebar({ visible: val })"
      @hidden="clear"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h4>{{ (newEmployeeSidebar.id? 'Editar':'Novo') + ' ' + affiliationTypeName }} 
          </h4>
          <div>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hide"
            />
          </div>
        </div>
        <!-- Form -->
        <div v-if="loading.form" class="d-flex justify-content-center align-items-center">
          <b-spinner
            class="text-primary"
            label="Carregando..."
          />
        </div>
        <b-form
          v-else
          class="p-2"
          @submit.prevent="onSubmit"
          @reset.prevent="resetForm"
        >
          <b-row>
            <b-col cols="12">
              <b-form-group label="Nome" label-for="consultant-name">
                <b-form-input
                  id="consultant-name"
                  v-model="name"
                  :class="{ 'is-invalid': v$.name.$error }"
                />
                <div class="invalid-feedback">
                  <span v-if="v$.name.$invalid">
                    Você deve informar um nome
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="newEmployeeSidebar.affiliationType == affiliationTypes.NETWORKER">
              <b-form-group label="E-mail" label-for="networker-email" class="mt-1">
                <b-form-input
                  id="networker-email"
                  v-model="networkerEmail"
                  :class="{ 'is-invalid': v$.networkerEmail.$error }"
                />
                <div class="invalid-feedback">
                  <span v-if="v$.networkerEmail.$invalid">
                    O e-mail informado é inválido
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-else>
              <label for="consultant-email" class="mt-1"> E-mail Futuro </label>
              <b-input-group
                append="@futurocorp.com.br"
                id="consultant-email-group"
                :class="{ 'is-invalid': v$.email.$error }"
              >
                <b-form-input id="consultant-email" v-model="email" />
              </b-input-group>
              <div class="invalid-feedback">
                <span v-if="v$.email.$invalid">
                  Você deve informar somente o prefixo do email no formato
                  nome.sobrenome
                </span>
              </div>
            </b-col>
            <b-col cols="12">
              <b-form-group label="CPF" label-for="cpf" class="mt-1">
                <b-form-input
                  id="cpf"
                  v-mask="'###.###.###-##'"
                  v-model="cpf"
                  :class="{ 'is-invalid': v$.cpf.$error }"
                />
                <div class="invalid-feedback">
                  <span v-if="v$.cpf.$invalid">
                    O CPF informado é inválido
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Tipo de Contrato" label-for="contract-type" class="mt-1">
                <v-select
                  id="contract-type"
                  v-model="contractType"
                  :options="userContractTypes"
                  label="name"
                  :reduce="contractType => contractType.id"
                  :class="getSelectErrorClass(v$.contractType.$error)"
                  :loading="loading.userContractTypes"
                >
                  <template #no-options="{ search, searching, loading }">
                    Sem resultados
                  </template>
                </v-select>
                <div class="invalid-feedback">
                  <span v-if="v$.contractType.$invalid">
                    Você deve selecionar um tipo de contrato
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="pjSelected">
              <b-form-group label="CNPJ" label-for="cnpj" class="mt-1">
                <b-form-input
                  id="cnpj"
                  v-mask="'XX.XXX.XXX/XXXX-##'"
                  v-model="cnpj"
                  style="text-transform: uppercase"
                  :class="{ 'is-invalid': v$.cnpj.$error }"
                />
                <div class="invalid-feedback">
                  <span v-if="v$.cnpj.$invalid">
                    O CNPJ informado é inválido
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="Celular"
                label-for="consultant-cellphone"
                class="mt-1"
              >
                <vue-tel-input
                  id="consultant-cellphone"
                  v-model="cellphone"
                  :class="{ 'is-invalid': v$.cellphone.$error }"
                />
                <div class="invalid-feedback">
                  <span v-if="v$.cellphone.$invalid">
                    Você deve informar um telefone válido
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="newEmployeeSidebar.affiliationType == affiliationTypes.EMPLOYEE">
              <b-form-group
                label="E-mail pessoal"
                label-for="consultant-contact-email"
                class="mt-1"
              >
                <b-form-input
                  id="consultant-contact-email"
                  v-model="contactEmail"
                  :class="{ 'is-invalid': v$.contactEmail.$error }"
                />
                <div class="invalid-feedback">
                  <span v-if="v$.contactEmail.$invalid">
                    Você deve informar um email válido
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="Estado"
                label-for="addressState"
                class="mt-1"
              >
                <v-select
                  id="addressState"
                  v-model="addressState"
                  :reduce="(addressStates) => addressStates.id"
                  :options="addressStates"
                  label="name"
                  :class="getSelectErrorClass(v$.addressState.$error)"
                >
                  <template #no-options="{ search, searching, loading }">
                    Sem resultados
                  </template>
                </v-select>
                <div class="invalid-feedback">
                  <span v-if="v$.addressState.$invalid">
                    Você deve informar um estado
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Cidade" label-for="addressCity" class="mt-1">
                <v-select
                  id="addressCity"
                  v-model="addressCity"
                  :reduce="(addressCities) => addressCities.id"
                  :options="addressCities"
                  label="name"
                  :class="getSelectErrorClass(v$.addressCity.$error)"
                >
                  <template #no-options="{ search, searching, loading }">
                    Sem resultados
                  </template>
                </v-select>
                <div class="invalid-feedback">
                  <span v-if="v$.addressCity.$invalid">
                    Você deve informar uma cidade
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12" 
              :md="newEmployeeSidebar.affiliationType == affiliationTypes.EMPLOYEE? 6: 12"
            >
              <b-form-group
                label="Formação"
                label-for="schoolLevel"
                class="mt-1"
              >
                <v-select
                  id="schoolLevel"
                  v-model="schoolLevel"
                  :reduce="(schoolLevels) => schoolLevels.id"
                  :options="schoolLevels"
                  label="name"
                >
                  <template #no-options="{ search, searching, loading }">
                    Sem resultados
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <template v-if="newEmployeeSidebar.affiliationType == affiliationTypes.NETWORKER">
              <b-col cols="12" md="12">
                <percentage-input
                  id="networker-solutions-percentage"
                  label="Percentual de comissão para EPs"
                  v-model="epCommissionPercentage"
                  class="mt-1"
                  :thereIsError="v$.epCommissionPercentage.$error && v$.epCommissionPercentage.$invalid"
                  errorMessage="Você deve fornecer uma porcentagem válida"
                />
              </b-col>
              <b-col cols="12" md="12">
                <percentage-input
                  id="networker-ep-percentage"
                  label="Percentual de comissão para soluções"
                  v-model="solutionsCommissionPercentage"
                  class="mt-1"
                  :thereIsError="v$.solutionsCommissionPercentage.$error && v$.solutionsCommissionPercentage.$invalid"
                  errorMessage="Você deve fornecer uma porcentagem válida"
                />
              </b-col>
            </template>
            <template v-else>
              <b-col cols="12" md="6">
                <b-form-group 
                  label="Departamento" 
                  label-for="consultant-department"
                  class="mt-1"
                  >
                  <v-select
                    id="consultant-department"
                    v-model="department"
                    :reduce="department => department.id"
                    :options="departments"
                    label="name"
                    dir="ltr"
                    :class="getSelectErrorClass(v$.department.$error)"
                  >
                    <template #no-options="{ search, searching, loading }">
                      Sem resultados
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group label="Perfil" label-for="consultant-role">
                  <v-select
                    id="consultant-role"
                    v-model="consultantRole"
                    :reduce="(role) => role.id_consultant_role"
                    :options="roles"
                    label="name"
                    :class="getSelectErrorClass(v$.consultantRole.$error)"
                  />
                  <div class="invalid-feedback">
                    <span v-if="v$.consultantRole.required.$invalid">
                      Você deve informar um novo nível para o consultor
                    </span>
                  </div>
                </b-form-group>
              </b-col>
            </template>

            <b-col cols="12" md="12">
              <b-form-group
                label="Data de nascimento"
                label-for="user-birth-date"
                class="mt-1"
              >
                <b-form-input
                  id="user-birth-date"
                  v-model="birthDate"
                  v-mask="'##/##/####'"
                  :class="{ 'is-invalid': v$.birthDate.$error }"
                />
                <div class="invalid-feedback">
                  <span
                    v-if="
                      v$.birthDate.minLength.$invalid || v$.birthDate.$invalid
                    "
                  >
                    A data informada é inválida
                  </span>
                </div>
              </b-form-group>
            </b-col>

          </b-row>
          <!-- Form Actions -->
          <div class="d-flex mt-2 justify-content-between">
            <b-button
              :disabled="saving"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              @click="hide"
              class="consultant-buttons"
            >
              Voltar
            </b-button>
            <b-button
              :disabled="saving"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              class="consultant-buttons"
            >
              {{ saving ? "Salvando..." : "Salvar" }}
            </b-button>
          </div>
        </b-form>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormFile,
  BButton,
  BFormTextarea,
  BFormInput,
  BInputGroup,
  BCol,
  BRow,
} from "bootstrap-vue";
import { mapActions, mapMutations, mapGetters } from "vuex";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf, helpers, minLength } from "@vuelidate/validators";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import DynamicSelect from "@/modules/shared/components/DynamicSelect";
import * as types from "../store/types";
import * as sharedTypes from "@/modules/shared/store/types";
import {
  onlyDigits,
  normalizeCnpj,
  dateToString,
  stringToDate,
  percentageToFloat,
  floatToPercentage
} from "@/helpers/converters";
import cpfIsValid from "@/validators/cpf";
import cnpjIsValid from "@/validators/cnpj";
import { getVueSelectErrorClass } from "@/helpers/validators";
import { assertBooleanOptions } from "@/constants/assertions";
import { USER } from "@/modules/account/store/types";
import { isBackofficeRole } from "@/constants/auth";
import * as affiliationTypes from "@/constants/affiliation_types";
import { PJ } from "@/constants/user_contract_types"
import PercentageInput from '@/modules/shared/components/PercentageInput';

const alphaNameDotName = helpers.regex(/^[a-z]+\.[a-z]+$/);
const alphaEmail = helpers.regex(
  /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/
);

export default {
  components: {
    BButton,
    BSidebar,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BFormFile,
    BCol,
    BRow,
    vSelect,
    DynamicSelect,
    BInputGroup,
    PercentageInput
  },
  props: {
    callback: Function,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      affiliationTypes,
      assertBooleanOptions,
      loading: {
        form: false,
        addressStates: false,
        addressCities: false,
        schoolLevels: false,
        consultants: false,
        userContractTypes: false,
      },
      name: undefined,
      email: undefined,
      cpf: undefined,
      cellphone: undefined,
      contactEmail: undefined,
      addressState: undefined,
      addressCity: undefined,
      schoolLevel: undefined,
      saving: false,
      birthDate: undefined,
      department: undefined,
      consultantRole: undefined,
      contractType: undefined,
      cnpj: undefined,
      networkerEmail: undefined,
      epCommissionPercentage: undefined,
      solutionsCommissionPercentage: undefined,
    };
  },
  setup() {
    return { toast: useToast(), v$: useVuelidate() };
  },
  validations() {
    return {
      name: { required },
      cellphone: {
        minLength(value) {
          return value.length >= 9;
        },
        maxLength(value) {
          return value.length <= 20;
        },
      },
      email: {
        required: requiredIf(() => {
          return this.newEmployeeSidebar.affiliationType == affiliationTypes.EMPLOYEE
        }),
        alphaNameDotName,
      },
      cpf: {
        required,
        valid(value) {
          return !value || cpfIsValid(value);
        },
      },
      cnpj: {
        required: helpers.withMessage(
          'O CNPJ é obrigatório para PJ',
          (value) => !this.pjSelected || (value && cnpjIsValid(value))
        ),
        valid: helpers.withMessage(
          'O CNPJ informado é inválido',
          (value) => !this.pjSelected || cnpjIsValid(value)
        ),
      },
      contactEmail: {
        required: requiredIf(() => {
          return this.newEmployeeSidebar.affiliationType == affiliationTypes.EMPLOYEE
        }),
        alphaEmail,
      },
      addressState: { required },
      addressCity: { required },
      schoolLevel: {},
      birthDate: {
        required,
        minLength: minLength(10),
      },
      department: { 
        required: requiredIf(() => {
          return this.newEmployeeSidebar.affiliationType == affiliationTypes.EMPLOYEE
        })
       },
      consultantRole: { 
        required: requiredIf(() => {
          return this.newEmployeeSidebar.affiliationType == affiliationTypes.EMPLOYEE
        })
      },
      contractType: { required },
      networkerEmail: {
        required: requiredIf(() => {
          return this.newEmployeeSidebar.affiliationType == affiliationTypes.NETWORKER
        }),
        alphaEmail
      },
      epCommissionPercentage: {
        required: requiredIf(() => {
          return this.newEmployeeSidebar.affiliationType == affiliationTypes.NETWORKER
        }),
        valid(value) {
          return !value || percentageToFloat(value) >= 0 && percentageToFloat(value) <= 99;
        },
      },
      solutionsCommissionPercentage: {
        required: requiredIf(() => {
          return this.newEmployeeSidebar.affiliationType == affiliationTypes.NETWORKER
        }),
        valid(value) {
          return !value || percentageToFloat(value) >= 0 && percentageToFloat(value) <= 99;
        },
      }
    };
  },
  computed: {
    ...mapGetters({
      newEmployeeSidebar: types.NEW_EMPLOYEE_SIDEBAR,
      addressStates: sharedTypes.ADDRESS_STATES,
      addressCities: sharedTypes.ADDRESS_CITIES,
      schoolLevels: sharedTypes.SCHOOL_LEVELS,
      user: USER,
      consultants: sharedTypes.CONSULTANTS,
      departments: sharedTypes.DEPARTMENTS,
      roles: sharedTypes.ROLES_EMPLOYEES,
      userContractTypes: sharedTypes.USER_CONTRACT_TYPES,
    }),
    isAdm: function () {
      return isBackofficeRole(this.user?.user_contract_type_id);
    },
    pjSelected() {
      return this.contractType === PJ;
    },
    saveMethod() {
      return this.newEmployeeSidebar.affiliationType == affiliationTypes.NETWORKER
        ? this.saveNetworker
        : this.saveEmployee;
    },
    getMethod() {
      return this.newEmployeeSidebar.affiliationType == affiliationTypes.NETWORKER
        ? this.getNetworker
        : this.getEmployee;
    },
    affiliationTypeName(){
      return this.newEmployeeSidebar.affiliationType == affiliationTypes.NETWORKER
        ? 'networker'
        : 'colaborador'
    }
  },
  mounted() {
    this.loading.addressStates = true;
    this.getAddressStates()
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar os estados para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        this.loading.addressStates = false;
      });
    this.loading.addressCities = true;
    this.getAddressCities()
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar as cidades para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        this.loading.addressCities = false;
      });
    this.loading.schoolLevels = true;
    this.getSchoolLevels()
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar as formações para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        this.loading.schoolLevels = false;
      });
    this.loading.consultants = true;
    this.getConsultants()
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar os consultores para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        this.loading.consultants = false;
      });
    this.getDepartments()
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: 'Oops!',
            text: 'Ocorreu um erro ao carregar a lista de departamentos para seleção. Entre em contato com o setor de TI.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      });
    this.getRoles()
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar os níveis para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
    if(this.newEmployeeSidebar.affiliationType){
      this.loading.userContractTypes = true;
      this.getUserContractTypes(this.newEmployeeSidebar.affiliationType).catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao carregar os tipos de contratos para seleção. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }).finally(() => {
        this.loading.userContractTypes = false;
      });
    }
  },
  methods: {
    ...mapMutations({
      mutateNewEmployeeSidebar: types.MUTATE_NEW_EMPLOYEE_SIDEBAR,
    }),
    ...mapActions({
      saveEmployee: types.SAVE_EMPLOYEE,
      saveNetworker: types.SAVE_NETWORKER,
      getEmployee: types.GET_EMPLOYEE,
      getNetworker: types.GET_NETWORKER,
      getLeadByCustomer: sharedTypes.GET_LEAD_BY_CUSTOMER,
      getAddressStates: sharedTypes.GET_ADDRESS_STATES,
      getAddressCities: sharedTypes.GET_ADDRESS_CITIES,
      getSchoolLevels: sharedTypes.GET_SCHOOL_LEVELS,
      getConsultants: sharedTypes.GET_CONSULTANTS,
      getDepartments: sharedTypes.GET_DEPARTMENTS,
      getRoles: sharedTypes.GET_ROLES_EMPLOYEES,
      getUserContractTypes: sharedTypes.GET_USER_CONTRACT_TYPES
    }),
    onShow() {
      this.saving = false;
      if(this.newEmployeeSidebar.id) {
        this.loading.form = true;
        this.getMethod(this.newEmployeeSidebar.id)
          .then((response) => {
            const employee = response.data;
            this.name = employee.name;
            this.email = employee.email? employee.email.split("@")[0]:undefined;
            this.cpf = employee.cpf;
            this.cellphone = employee.cell_phone;
            this.contactEmail = employee.personal_email;
            this.addressState = employee.address_state_id;
            this.addressCity = employee.address_city_id;
            this.schoolLevel = employee.school_level_id;
            this.birthDate = dateToString(employee.birth_date);
            this.department = employee.department_id;
            this.consultantRole = employee.user_role_id;
            this.contractType = employee.contract_type_id;
            if (this.contractType === PJ) {
              this.cnpj = employee.cnpj;
            }
            if (employee.networker_email) {
              this.networkerEmail = employee.networker_email;
            }
            if (employee.ep_commission_percentage) {
              this.epCommissionPercentage = floatToPercentage(employee.ep_commission_percentage * 100);
            }
            if(employee.solutions_commission_percentage) {
              this.solutionsCommissionPercentage = floatToPercentage(employee.solutions_commission_percentage * 100);
            }
          })
          .catch((err) => {
            if (err?.response?.status == 404) {
              this.toast({
                component: ToastificationContent,
                props: {
                  title: "Oops!",
                  text: this.affiliationTypeName + " não encontrado.",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
              return;
            }
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: `Ocorreu um erro ao carregar os dados do ${this.affiliationTypeName}. Entre em contato com o setor de TI.`,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.loading.form = false;
          });
      }
    },
    async onSubmit() {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;
      this.saving = true;
      const { name, email } = this;
      const payload = {
        id: this.newEmployeeSidebar.id,
        name,
        email,
        cpf: onlyDigits(this.cpf),
        cell_phone: onlyDigits(this.cellphone),
        personal_email: this.contactEmail,
        address_state_id: this.addressState,
        address_city_id: this.addressCity,
        school_level_id: this.schoolLevel,
        department_id: this.department,
        user_role_id: this.consultantRole,
        birth_date: stringToDate(this.birthDate),
        cnpj: this.pjSelected? normalizeCnpj(this.cnpj):undefined,
        contract_type_id: this.contractType,
        networker_email: this.networkerEmail,
        ep_commission_percentage: percentageToFloat(this.epCommissionPercentage) / 100,
        solutions_commission_percentage: percentageToFloat(this.solutionsCommissionPercentage) / 100,
      };
      
      this.saveMethod(payload)
        .then((response) => {
          let successMessage = "Colaborador salvo com sucesso! Contrato enviado para o email pessoal!";
          if(this.newEmployeeSidebar.affiliationType == affiliationTypes.NETWORKER){
            successMessage = "Networker salvo com sucesso!";
          }
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Sucesso",
              text: successMessage,
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
          this.mutateNewEmployeeSidebar({ visible: false });
          this.newEmployeeSidebar.saveAction();
        })
        .catch((err) => {
          if (err?.response?.status == 405) {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: err.response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          } else {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: `Ocorreu um erro ao salvar o ${this.affiliationTypeName}. Entre em contato com o setor de TI.`,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },
    clear() {
      this.name = undefined;
      this.email = undefined;
      this.cellphone = undefined;
      this.contactEmail = undefined;
      this.addressState = undefined;
      this.addressCity = undefined;
      this.schoolLevel = undefined;
      this.birthDate = undefined;
      this.showChangeFields = false;
      this.department = undefined;
      this.consultantRole = undefined;
      this.contractType = undefined;
      this.cnpj = undefined;
      this.networkerEmail = undefined;
      this.cpf = undefined;
      this.epCommissionPercentage = undefined;
      this.solutionsCommissionPercentage = undefined;
      this.mutateNewEmployeeSidebar({ id: undefined, affiliationType: undefined });
      this.v$.$reset();
    },
    getSelectErrorClass(thereIsError) {
      return getVueSelectErrorClass(thereIsError);
    },
  },
};
</script>

<style lang="scss" scoped>
.vue-tel-input {
  padding: 0.438rem 1rem;
}
</style>
<style lang="scss">
.sidebar-xg {
  width: 36rem;
}

.consultant-buttons {
  width: 10rem;
}
</style>
